import { render, staticRenderFns } from "./difLine.vue?vue&type=template&id=8d96c8be&scoped=true"
import script from "./difLine.vue?vue&type=script&lang=js"
export * from "./difLine.vue?vue&type=script&lang=js"
import style0 from "./difLine.vue?vue&type=style&index=0&id=8d96c8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d96c8be",
  null
  
)

export default component.exports